exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".region-panel {\n  padding: .25em;\n  background: pink;\n  position: fixed;\n  top: .5em;\n  left: .5em;\n  z-index: 10000; }\n  .region-panel td:first-child {\n    text-align: right; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js!./src/components/QbTabs/components/scss/regionPanel.scss
// module id = 933
// module chunks = 1